import * as TYPES from './ErrorTypes';

const initialState = {
  errorType: null,
  shouldShowErrorInPage: false, // current behavior all errors are being redirected to /error page
};

export default function errorReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case TYPES.SET_SHOULD_SHOW_ERROR_IN_PAGE:
      return {
        ...state,
        shouldShowErrorInPage: payload
      };
    case TYPES.SET_ERROR_TYPE:
      return {
        ...state,
        errorType: payload,
      };
    case TYPES.RESET_ERROR_STATE: {
      return {
        ...initialState,
      };
    }
    default:
      return {
        ...state,
      };
  }
}
